import { Box } from '@mui/material';
import React, { useCallback, MouseEvent, MutableRefObject, forwardRef, ForwardedRef } from 'react';
import { useReactFlow } from 'reactflow';
import { rootNodeTypes } from '../../config/config-designer';
import NodeStore from '../../stores/NodeStore';

type Props = {
    id: string,
    top: number | undefined,
    left: number | undefined,
    position: 'fixed' | 'relative' | 'absolute',
    createNode: (type: string, x: number, y: number) => void,
    clientX: number,
    clientY: number,
    onClose: ()=> void
}

const ContextMenu = forwardRef(({ id, top, left, position, createNode, clientX, clientY, onClose }: Props, ref: ForwardedRef<HTMLDivElement>) => {
    const { getNode, setNodes, addNodes, setEdges } = useReactFlow();
    const functions = NodeStore.useState(s => s.functions);

    const duplicateNode = useCallback(() => {
        //const node = getNode(id);
        //const position = {
        //    x: node.position.x + 50,
        //    y: node.position.y + 50,
        //};

        //addNodes({ ...node, id: `${node.id}-copy`, position });
    }, [id, getNode, addNodes]);

    const deleteNode = useCallback(() => {
        setNodes((nodes) => nodes.filter((node) => node.id !== id));
        setEdges((edges) => edges.filter((edge) => edge.source !== id));
    }, [id, setNodes, setEdges]);

    return (
        <div className="context" ref={ref}            
            onClick={(event: MouseEvent<HTMLDivElement>) => {
                event.preventDefault();
                event.stopPropagation();
                return false;
            }}
            style={{
                top, left, position: position
            }}
        >
            {rootNodeTypes.map(nodeType => <div className="context_item">
                <div className="inner_item" onClick={() => { createNode(nodeType.type, clientX, clientY); onClose(); }}>
                    {nodeType.label }
                </div>
            </div>) }
        </div>
    )
})

export default ContextMenu;